export const DEFAULT_AWS_PRESIGNED_URL_CACHE_FALLBACK_TTL_MS = 110_000;
export const DEFAULT_AWS_PRESIGNED_URL_CACHE_SAFETY_BUFFER_MS = 10_000;

export interface PresignedUrlCacheExpiresAtOptions {
  now?: number;
  fallbackTtlMs?: number;
  safetyBufferMs?: number;
}

export function getPresignedUrlCacheExpiresAt(
  url: string,
  {
    now = Date.now(),
    fallbackTtlMs = DEFAULT_AWS_PRESIGNED_URL_CACHE_FALLBACK_TTL_MS,
    safetyBufferMs = DEFAULT_AWS_PRESIGNED_URL_CACHE_SAFETY_BUFFER_MS,
  }: PresignedUrlCacheExpiresAtOptions = {},
) {
  const parsedExpiresAt = getAwsPresignedUrlExpiresAt(url);
  if (!parsedExpiresAt) {
    return now + fallbackTtlMs;
  }

  return Math.max(now, parsedExpiresAt - safetyBufferMs);
}

export function getAwsPresignedUrlExpiresAt(url: string) {
  try {
    const parsedUrl = new URL(url);
    const amzDate = parsedUrl.searchParams.get('X-Amz-Date');
    const amzExpires = parsedUrl.searchParams.get('X-Amz-Expires');
    if (!amzDate || !amzExpires) {
      return undefined;
    }

    const signedAt = parseAwsDate(amzDate);
    const expiresInSeconds = Number.parseInt(amzExpires, 10);
    if (!signedAt || !Number.isFinite(expiresInSeconds)) {
      return undefined;
    }

    return signedAt + expiresInSeconds * 1000;
  } catch {
    return undefined;
  }
}

export function parseAwsDate(value: string) {
  const match = /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/.exec(value);
  if (!match) {
    return undefined;
  }

  const [, year, month, day, hour, minute, second] = match;
  return Date.UTC(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second),
  );
}
